'use client'

import { useAbTest } from 'ab-test/hooks/useAbTest/useAbTest'
import { featureFlagKeys } from 'feature-flags/constants/featureFlags'
import { useFeatureFlag } from 'feature-flags/hooks/useFeatureFlag/useFeatureFlag'
import { AbTestKeys } from 'types/constants/AbTestKeys'

export const usePdpNewVision = () => {
	const { enabled: enabledFeatureFlag } = useFeatureFlag(
		featureFlagKeys.PdpNewVisionMvp
	)
	const enabledABTest = useAbTest({ key: AbTestKeys.PdpNewVisionMvp })

	return { enabled: enabledFeatureFlag || enabledABTest?.enabled }
}
